import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/styles";
import AgyleDialog from "../components/modal/agyleDialog";

export default function MessageBoxRefresh(props) {
  // const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const [disabledAccept, setDisabledAccept] = useState(false);

  const handleClose = (event, type) => {
    props.onClose(event, type);
  };

  const handleAccept = () => {
    setDisabledAccept(props.disableOnAccept);
    props.onAccept();
  };

  const handlePressEnter = (e) => {
    if (
      props.submitOnEnter &&
      e?.code === "Enter" &&
      !props.disableSave &&
      !props.disabled
    ) {
      handleAccept();
    }
  };

  useEffect(() => {
    if (props.open) setDisabledAccept(false);
  }, [props.open]);

  return (
    <AgyleDialog
      open={props.open}
      title={props.title}
      maxWidth={props.width}
      fullWidth={props.fullWidth}
      onKeyDown={handlePressEnter}
      cancelColour={props.warning ? "error" : ""}
      closeButtonOnHeader={!props.disableCloseCross}
      disableActionsCloseButton={!props?.haveAccept?.no}
      onSave={props.haveAccept ? handleAccept : handleClose}
      onClose={props.disableBackgroundClick ? null : handleClose}
      submitText={t(props.haveAccept?.yes || "Ok")}
      cancelText={t(props.haveAccept?.no || "Close")}
      disableSave={props.disableSave ? props.disabled : disabledAccept}
    >
      <div>
        {props?.messageObject && props?.messageObject}

        {!props?.messageObject && (
          <div
            dangerouslySetInnerHTML={{
              __html: props?.message,
            }}
          />
        )}
      </div>
    </AgyleDialog>
  );
}

MessageBoxRefresh.propTypes = {
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
  open: PropTypes.bool,
  disableSave: PropTypes.bool,
  disabled: PropTypes.bool,
  disableBackgroundClick: PropTypes.bool,
  disableCloseCross: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  messageObject: PropTypes.any,
  haveAccept: PropTypes.object,
  warning: PropTypes.bool,
  minWidth: PropTypes.number,
  width: PropTypes.oneOf(["xl", "md", "sm", "xs", "lg", false]),
  fullWidth: PropTypes.bool,
  submitOnEnter: PropTypes.bool,
  disableOnAccept: PropTypes.bool,
};

MessageBoxRefresh.defaultProps = {
  disableBackgroundClick: false,
  disableCloseCross: false,
  disableSave: false,
  disabled: false,
  warning: false,
  messageObject: null,
  title: "Message",
  message: "",
  minWidth: 0,
  width: "sm",
  fullWidth: false,
  submitOnEnter: false,
  disableOnAccept: false,
};
